import { Vehicle } from '../../shared/types'
import { useObjectGetBatched } from '../api/object'

export function getVehicleLabelText(vehicle?: Partial<Pick<Vehicle, 'name' | 'license_plate'>>) {
	if (!vehicle) return ''
	if (!vehicle.license_plate) return vehicle.name
	return `${vehicle.name} (${vehicle.license_plate})`
}

export function getVehicleLabel(vehicle?: Partial<Pick<Vehicle, 'name' | 'license_plate'>>) {
	if (!vehicle) return ''
	if (!vehicle.license_plate) return vehicle.name
	return (
		<>
			{vehicle.name} <span className="text-gray-600">({vehicle.license_plate})</span>
		</>
	)
}

export function VehicleFormatter({ id }: { id?: string }) {
	const { data: vehicle } = useObjectGetBatched('vehicle', id)

	if (!id) return <em className="text-gray-400">nevyplněno</em>

	return <>{getVehicleLabel(vehicle)}</>
}
